import React, { useContext } from 'react';
import { Box, Divider } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { NavLink, useLocation } from 'react-router-dom';
import { AuthContext } from 'authentication/AuthContext';
import { useUserRolePermissions } from 'hooks';
import Flag from 'common/FeatureFlags/Flag';

const DesktopNavTabs = () => {
  const { currentAffiliate } = useContext(AuthContext);
  const {
    isInventoryOwner,
    isProductLoadingView,
    isProductOwnerView,
    isProductShippingManage,
    isProductShippingView,
    isSupplier,
    isUser,
  } = useUserRolePermissions();
  const theme = useTheme();
  const baseRoute = `/affiliate/${currentAffiliate?.customerIdName}/${currentAffiliate?.dataCompanyId}`;
  const routePath = useLocation().pathname.split('/');

  const navLinkStyles = {
    '&:hover': {
      backgroundColor: 'secondary.light',
    },
    alignItems: 'center',
    display: 'flex',
    height: 45,
    justifyContent: 'center',
    lineHeight: 'normal',
    minWidth: 88,
    p: (0, 1),
  };
  const miniTabsActive = {
    borderBottom: '1px solid',
    borderColor: theme.palette.primary.dark,
    color: theme.palette.primary.dark,
    fontSize: 14,
    textDecoration: 'none',
  };
  const miniTabInActive = {
    color: theme.palette.secondary.main,
    textDecoration: 'none',
  };

  return (
    !!isUser && (
      <>
        <NavLink
          className="heap-button"
          end
          style={({ isActive }) => (isActive ? miniTabsActive : miniTabInActive)}
          to={`${baseRoute}`}
        >
          <Box sx={navLinkStyles}>Home</Box>
        </NavLink>

        {isInventoryOwner && isProductOwnerView && (
          <Flag value={process.env.REACT_APP_LD_INVENTORY}>
            <NavLink
              className="heap-button"
              style={({ isActive }) =>
                isActive || routePath.includes('inventory-management')
                  ? miniTabsActive
                  : miniTabInActive
              }
              to={`${baseRoute}/inventory-management/dashboard`}
            >
              <Box sx={navLinkStyles}>Inventory</Box>
            </NavLink>
          </Flag>
        )}
        {isInventoryOwner && (isProductShippingView || isProductShippingManage) && (
          <Flag value={process.env.REACT_APP_LD_SHIPPING}>
            <NavLink
              style={({ isActive }) => (isActive ? miniTabsActive : miniTabInActive)}
              to={`${baseRoute}/shipping`}
            >
              <Box sx={navLinkStyles}>Shipping</Box>
            </NavLink>
          </Flag>
        )}
        {(isSupplier || isInventoryOwner) && isProductLoadingView && (
          <Flag value={process.env.REACT_APP_LD_LOADING}>
            <NavLink
              className="heap-button"
              style={({ isActive }) => (isActive ? miniTabsActive : miniTabInActive)}
              to={`${baseRoute}/loading-management`}
            >
              <Box sx={navLinkStyles}>Loading</Box>
            </NavLink>
          </Flag>
        )}
        <Flag value={process.env.REACT_APP_LD_DISPATCHING}>
          <NavLink
            className="heap-button"
            style={({ isActive }) =>
              isActive || routePath.includes('dispatching') ? miniTabsActive : miniTabInActive
            }
            to={`${baseRoute}/dispatching`}
          >
            <Box sx={navLinkStyles}>Dispatching</Box>
          </NavLink>
        </Flag>
        <Flag value={process.env.REACT_APP_LD_GLOBAL}>
          <NavLink
            className="heap-button"
            style={({ isActive }) => (isActive ? miniTabsActive : miniTabInActive)}
            to={`${baseRoute}/global-data`}
          >
            <Box sx={navLinkStyles}>Global</Box>
          </NavLink>
        </Flag>
        <Divider flexItem orientation="vertical" />
      </>
    )
  );
};

export default DesktopNavTabs;
